export const getInitials = (fullName) => {
  if (fullName?.length > 0) {
    const parts = fullName.split(' ');
    const initials = parts?.map((p) => p.charAt(0)).join('');
    return initials.toUpperCase();
  }
};
